import { useQueryClient } from '@tanstack/react-query';
import { Dispatch, SetStateAction } from 'react';
import { useSearchParams } from 'react-router-dom';
import SharedGridStateIconButton from '../../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../../shared/analytics/module-list';
import SharedToolbar from '../../../../shared/shared-toolbar-latest';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button';
interface DecomLogGridToolbarProps {
  selectedRows: string[];
  setPaginationModel: Dispatch<
    SetStateAction<{
      pageSize: number;
      page: number;
      cursor: string | null;
      suspendedUserModelId: string | null;
      acknowledged: boolean | null;
    }>
  >;
  setOpenAcknowledgeDialog: Dispatch<SetStateAction<boolean>>;
  setOpenCompleteDialog: Dispatch<SetStateAction<boolean>>;
  acknowledgedFilter: boolean | null;
}

export default function DecomLogGridToolbar({
  selectedRows,
  setPaginationModel,
  setOpenAcknowledgeDialog,
  setOpenCompleteDialog,
  acknowledgedFilter,
}: DecomLogGridToolbarProps) {
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');

  return (
    <SharedToolbar
      secondaryButtons={
        <>
          <SharedIconButton
            variant="acknowledge"
            onClick={() => setOpenAcknowledgeDialog(true)}
            disabled={selectedRows.length === 0}
            tooltipLabel="Acknowledge"
          />
          <SharedIconButton
            variant="complete"
            onClick={() => setOpenCompleteDialog(true)}
            disabled={selectedRows.length === 0}
            tooltipLabel="Complete"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              setPaginationModel({
                pageSize: 100,
                page: 0,
                cursor: null,
                suspendedUserModelId: userId,
                acknowledged: acknowledgedFilter,
              });
              queryClient.invalidateQueries({ queryKey: ['DecomLogs'] });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="decomLogsGridStates"
            module={ModuleList.modules.automation.name}
            section={ModuleList.modules.automation.sections.decomLogs}
          />
        </>
      }
    />
  );
}
